export default __webpack_public_path__ + "static/media/allgemein_27.27567f54.jpg";